<template>
  <div class="exam-result">
    <div class="holder-result">
      <div class="result">
        <p class="your-result">
          Your Result:
        </p>
        <p class="title">
          {{ testTitle }}
        </p>
        <p class="subtitle">
          {{ testSubtitle }}
        </p>
        <div class="answers desktop">
          <div>
            <span>Correct Answers:</span>
            <span class="correct">{{ testScore.correctAnswers }}</span>
          </div>
          <div>
            <span>Wrong Answers:</span>
            <span class="wrong">{{ testScore.incorrectAnswers }}</span>
          </div>
        </div>
      </div>
      <div class="progress-holder">
        <div class="progress">
          <Chart
            id="exam-result"
            slot="chart"
            type="doughnut"
            :data="chartData"
            :options="chartOptions"
          />
          <div class="number">
            <p>{{ testScore.score }}%</p>
            <p>Mastery</p>
          </div>
        </div>
      </div>
      <div class="answers mobile">
        <div>
          <span>Correct Answers:</span>
          <span class="correct">{{ testScore.correctAnswers }}</span>
        </div>
        <div>
          <span>Wrong Answers:</span>
          <span class="wrong">{{ testScore.incorrectAnswers }}</span>
        </div>
      </div>
    </div>
    <div v-if="!$route.path.includes('/results/')" class="btn-holder">
      <button class="btn-text" :disabled="!canRotate" @click="$emit('rotate')">
        Deck progress
      </button>
    </div>
  </div>
</template>

<script>
import Chart from '../../components/Chart';

export default {
  components: {
    Chart,
  },
  props: {
    testScore: { type: Object, required: true, default: () => ({}) },
    canRotate: { type: Boolean, required: false },
  },
  data() {
    return {
      chartData: {
        datasets: [
          {
            label: 'Dataset 1',
            data: [this.testScore.correctAnswers, this.testScore.incorrectAnswers],
            backgroundColor: ['#56BFC7', '#FF5050'],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        borderRadius: this.testScore.correctAnswers === 0 || this.testScore.incorrectAnswers === 0 ? 0 : 40,
        spacing: this.testScore.correctAnswers === 0 || this.testScore.incorrectAnswers === 0 ? 0 : 0.5,
        backgroundColor: 'red',
        borderWidth: 0,
        cutout: this.$store.state.layout === 'desktop' ? 90 : 70,
        borderAlign: 'inner',
        plugins: {
          legend: {
            display: false,
          },
          title: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        },
      },
    };
  },
  computed: {
    testTitle() {
      return this.testScore.score >= 60 ? 'Great work!' : 'Keep pushing forward!';
    },
    testSubtitle() {
      return this.testScore.score >= 60
        ? 'Congratulations, you’ve achieved 60% mastery or higher. Share your results or start a new deck from the library.'
        : 'You need at least 60% mastery. Dedicate more study time to upgrade your skillset. Remember, learning is a challenging but rewarding process.';
    },
  },
};
</script>
